module.exports = __webpack_public_path__ + "img/monsieur-la-doulaise.png";